import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SisinService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getSisin(): Observable<any> {
    return this.http.get(this.baseUrl + 'parSisin', { headers: this.header(this.token) });
  }
  getSisinActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parSisinActivos', { headers: this.header(this.token) });
  }
  
  getSisinById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parSisin/' + id, { headers: this.header(this.token) });
  }

  postSisin(Sisin: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parSisin', Sisin, { headers: this.header(this.token) });
  }

  putSisin(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parSisin', bodyString, { headers: this.header(this.token) });
  }

  deleteSisin(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parSisin/' + id, { headers: this.header(this.token) });
  }
  
}